export default {
  playable: {
    label: 'Playable Projects',
    projectInfo: 'Promoted Product Information (CTA or Landing Page)',
    delete: 'Delete Project',
    startCreate: 'Want to quickly start creating playable advertisements?',
    messageDes:
      'Start your first playable with lots of templates provided by Playturbo!',
    describe:
      'Element-level playable advertising production platform, compatible with all leading advertising networks and easy exports.',
    choice: 'Select Template',
    create: {
      name: 'Create Project',
      template: 'Choose Template',
      blank: 'Content Editor',
      iv: 'Video to Playable',
    },
    filter: {
      projectname: 'Project Name',
      projectid: 'Project ID',
      projectstatus: 'Project Status',
      edittime: 'Updated Time',
      createtime: 'Creation Time',
    },
    table: {
      project: 'Project Name and ID',
      productname: 'Product Name',
      Status: 'Project Status',
      demoTip: 'This project is a demo project, it has been pinned.',
      edittips: 'Edit',
      previewtips: 'Preview',
      applytips: 'Apply to Mintegral',
      downloadtips: 'Download',
      packChannel: 'Packaging Channel',
      pushFolder: 'Push Folder',
      detail: 'View Details',
    },
    more: 'More',
    moretemplates: 'More Templates',
    editProjectConfirm: {
      title: 'Edit',
      desc: 'This project is a demo project and cannot be edited.',
    },
    delProjectConfirm: {
      title: 'Delete',
      desc: 'This project is a demo project and cannot be deleted.',
    },
    detail: {
      templateName: 'Template Name',
      direction: 'Adaptation Orientation',
    },
    resetProjectLabel: 'Reset Demo Project',
    resetProjectConfirm: {
      title: 'Reset Demo Project',
      desc: 'Confirm to reset the Demo project？',
      error: 'The Demo project does not need to be reset',
      success: 'Reset Demo project successful',
      fail: 'Reset Demo project failed',
    },
  },
}
